const avatarColors: Record<string, string[]> = {
	'#be3227': ['#ffffff', '#f7fafa', '#f1fcfc'],
	'#f9cf62': ['#6a148c', '#234652', '#662108', '#172d35'],
	'#94cc3f': ['#234652', '#662108', '#172d35'],
	'#00B3AB': ['#172d35'],
	'#09589e': ['#ffe49d', '#d1ed7e', '#d0dbdb', '#f9ebea', '#fddfbf', '#fff1d0', '#f6fbe5', '#d0efec', '#d0dfed', '#e5d1ed', '#ffffff', '#dfeaea', '#e7f5be', '#e3f8f8', '#f7fafa', '#fff7e3', '#edf4f4', '#f1fcfc'],
	'#6a148c': ['#f9cf62', '#eba49f', '#ffe49d', '#d1ed7e', '#d0dbdb', '#f9ebea', '#fddfbf', '#fff1d0', '#f6fbe5', '#d0efec', '#d0dfed', '#e5d1ed', '#ffffff', '#dfeaea', '#e7f5be', '#e3f8f8', '#77e6e0', '#f7fafa', '#fff7e3', '#bdcccc', '#edf4f4', '#f1fcfc'],
	'#234652': ['#f9cf62', '#94cc3f', '#eba49f', '#f9a241', '#ffe49d', '#d1ed7e', '#73d6d3', '#d0dbdb', '#f9ebea', '#fddfbf', '#fff1d0', '#f6fbe5', '#d0efec', '#d0dfed', '#e5d1ed', '#ffffff', '#dfeaea', '#92b8b8', '#e7f5be', '#e3f8f8', '#77e6e0', '#f7fafa', '#fff7e3', '#bdcccc', '#edf4f4', '#f1fcfc'],
	'#eba49f': ['#6a148c', '#234652', '#662108', '#172d35'],
	'#f9a241': ['#234652', '#662108', '#172d35'],
	'#ffe49d': ['#09589e', '#6a148c', '#234652', '#a3340d', '#662108', '#172d35', '#347208'],
	'#d1ed7e': ['#09589e', '#6a148c', '#234652', '#662108', '#172d35', '#347208'],
	'#73d6d3': ['#234652', '#172d35'],
	'#72a6d3': ['#662108', '#172d35'],
	'#d0dbdb': ['#09589e', '#6a148c', '#234652', '#a3340d', '#662108', '#172d35'],
	'#fddfbf': ['#09589e', '#6a148c', '#234652', '#a3340d', '#662108', '#172d35', '#347208'],
	'#fff1d0': ['#09589e', '#6a148c', '#234652', '#55727b', '#a3340d', '#662108', '#172d35', '#347208'],
	'#d0efec': ['#09589e', '#6a148c', '#234652', '#172d35', '#347208'],
	'#d0dfed': ['#09589e', '#6a148c', '#234652', '#a3340d', '#662108', '#172d35'],
	'#e5d1ed': ['#09589e', '#6a148c', '#234652', '#a3340d', '#662108', '#172d35'],
	'#55727b': ['#fff1d0', '#f6fbe5', '#ffffff', '#e3f8f8', '#f7fafa', '#fff7e3', '#edf4f4', '#f1fcfc'],
	'#dfeaea': ['#09589e', '#6a148c', '#234652', '#a3340d', '#662108', '#172d35', '#347208'],
	'#a3340d': ['#ffe49d', '#d0dbdb', '#f9ebea', '#fddfbf', '#fff1d0', '#f6fbe5', '#d0efec', '#d0dfed', '#e5d1ed', '#ffffff', '#dfeaea', '#e7f5be', '#e3f8f8', '#f7fafa', '#fff7e3', '#edf4f4', '#f1fcfc'],
	'#662108': ['#f9cf62', '#94cc3f', '#eba49f', '#f9a241', '#ffe49d', '#d1ed7e', '#73d6d3', '#72a6d3', '#d0dbdb', '#f9ebea', '#fddfbf', '#fff1d0', '#f6fbe5', '#d0efec', '#d0dfed', '#e5d1ed', '#ffffff', '#dfeaea', '#92b8b8', '#e7f5be', '#e3f8f8', '#77e6e0', '#f7fafa', '#fff7e3', '#bdcccc', '#edf4f4', '#f1fcfc'],
	'#92b8b8': ['#234652', '#662108', '#172d35'],
	'#e7f5be': ['#09589e', '#6a148c', '#234652', '#a3340d', '#662108', '#172d35', '#347208'],
	'#172d35': ['#f9cf62', '#94cc3f', '#00B3AB', '#eba49f', '#f9a241', '#ffe49d', '#d1ed7e', '#73d6d3', '#72a6d3', '#d0dbdb', '#f9ebea', '#fddfbf', '#fff1d0', '#f6fbe5', '#d0efec', '#d0dfed', '#e5d1ed', '#ffffff', '#dfeaea', '#92b8b8', '#e7f5be', '#e3f8f8', '#77e6e0', '#f7fafa', '#fff7e3', '#bdcccc', '#edf4f4', '#f1fcfc'],
	'#e3f8f8': ['#09589e', '#6a148c', '#234652', '#55727b', '#a3340d', '#662108', '#172d35', '#347208'],
	'#77e6e0': ['#6a148c', '#234652', '#172d35'],
	'#347208': ['#ffe49d', '#d1ed7e', '#f9ebea', '#fddfbf', '#fff1d0', '#f6fbe5', '#d0efec', '#ffffff', '#dfeaea', '#e7f5be', '#e3f8f8', '#f7fafa', '#fff7e3', '#f1fcfc'],
	'#bdcccc': ['#6a148c', '#234652', '#662108', '#172d35']
};
const backgroundColors: string[] = Object.keys(avatarColors);

/**
 * Generates a positive hash number for a string using the DJB2 algorithm.
 * http://www.cse.yorku.ca/%7Eoz/hash.html
 * @param avatarSeed the string to hash
 */
export function hashAvatarSeed(avatarSeed: string): number {
	let hash = 0;
	if (!avatarSeed)
		return hash;
	for (let i = 0; i < avatarSeed.length; i++)
		hash = (((hash << 5) - hash) + avatarSeed.charCodeAt(i)) | 0;
	return Math.abs(hash);
}

/**
 * Extracts initials from first and last name, filtering special characters.
 * Matches server-side logic in IndexBuilder.GetImageFallback.
 */
export function extractInitials(first: string | undefined, last: string | undefined): string {
	let initials = '';

	if (first) {
		const c = first[0];
		// Filter pipe character (used as delimiter in image value)
		if (c !== '|')
			initials += c;
	}

	if (last) {
		const c = last[0];
		// Filter dash (would create "F-" prefix) and pipe characters
		if (c !== '-' && c !== '|')
			initials += c;
	}

	return initials.toUpperCase();
}

export function personLabel(label: string | null | undefined, email: string | null | undefined): string {
	return label?.trim() ? label : (email ?? '');
}

export function personInitials(first: string | undefined, last: string | undefined, email: string): string {
	return `${first ?? ''}${last ?? ''}`.trim() ? extractInitials(first, last) : extractInitials(email, undefined);
}

export type AvatarMeta = { FirstName?: string | null, LastName?: string | null, Email?: string, AvatarUrl?: string, IsDeleted?: boolean };

export function getAvatarSVG(user: AvatarMeta, overrideHash: number = null): string {
	const avatarSeed = overrideHash !== null ? overrideHash : hashAvatarSeed(user.Email);

	const firstInitial = ((user.FirstName ?? '').trim() !== '' ? user.FirstName : user.Email)?.trim()[0] ?? '';
	const lastInitial = (user.LastName ?? '').trim()[0] ?? '';
	const initials = (firstInitial + lastInitial).toUpperCase();

	// Shrink initials slightly for each M or W
	// transform has to be inline css style for IE
	// (it doesn't take effect in IE, which should support transform but not transform-origin)
	const scale = ((21 - initials.split(/W|M/).length) * .05).toFixed(2);

	let shift = '';
	if (firstInitial === 'J')
		shift = 'translate(14px, -11px);';
	else if (lastInitial === 'J' || lastInitial === 'Q')
		shift = 'translate(0, -6px);';

	const bgColor = backgroundColors[avatarSeed % backgroundColors.length]!;
	// Select a font color that is compatible with the background color
	// Shift the hash via division to increase variability (especially when background/font counts match)
	const fontColors = avatarColors[bgColor]!;
	const fontColor = fontColors[Math.round(avatarSeed / 11) % fontColors.length];

	const isDeleted = user?.IsDeleted ?? false;

	return `<svg viewBox="0 0 308 308">
	<circle cx="154" cy="154" r="${isDeleted ? '144' : '150'}" fill="${isDeleted ? 'transparent' : bgColor}" stroke="${isDeleted ? bgColor : 'transparent'}" stroke-width="20" stroke-dasharray="45 45" />
	${isDeleted ? `<circle cx="154" cy="154" r="144" fill="${bgColor}" opacity=".3" />` : ''}
    <text x="50%" y="68%" style="color: ${fontColor}; transform: scale(${scale}); ${shift} transform-origin: 50%" text-anchor="middle" class="avatar__initials icon--fill heavy">${initials}</text>
    </svg>`;
}

export function getAvatar(user: AvatarMeta, overrideHash: number = null): string {
	return user.AvatarUrl && user.AvatarUrl.trim() !== '' ? user.AvatarUrl : getAvatarSVG(user, overrideHash);
};
